










//Type the value and press ENTER to create a tag. Tag will be stored for future settings
import Vue from 'vue'
export default Vue.extend({
  functional: true
})
